import * as React from 'react';

export type LabelledElementProps = {
  dataHook?: string;
  label?: string;
  value?: string | number;
  disabled?: boolean;
  topLabelGray?: boolean;
  children?: ({
    id,
    onFocus,
    onBlur,
    onChange,
    className,
    getPlaceholder,
  }: {
    id: string;
    onFocus: () => void;
    onBlur: () => void;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className: string;
    getPlaceholder: (placeholder?: string) => string | undefined;
  }) => React.ReactNode;
};
